import styled from 'styled-components';
import { RootState } from 'store';
import { useSelector } from 'react-redux';

import { OrderStatusEnums } from 'order/enums/orderEnums';

import UtilService from 'shared/services/util.service';
import { ButtonSecondary } from 'shared/components/Button';
import { Modal } from 'shared/components/Modal';
import { ModalWrapper } from 'shared/components/ModalWrapper';
import { Wrapper } from 'shared/components/Wrapper';
import { useHasPermissions } from 'shared/hooks/useHasPermissions';
import { userPermissionsValues } from 'shared/enum/userPermissionsEnum';

import { testId } from 'tests/utils';

import {
  ACKTestButtonEnum,
  ACKTestContainerEnum,
} from 'tests/enums/ACKTestEnums';

import SpecialOrderApprovalModal from './SpecialOrderApprovalModal';

const DealerSORActionsContainer = styled(Wrapper)``;

interface DealerSORActionsProps {
  isContentLoaded: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DealerSORActions = ({ isContentLoaded }: DealerSORActionsProps) => {
  const order = useSelector((state: RootState) => state.orderReducer.order);

  const canSendSpecialOrderApproval = useHasPermissions(
    userPermissionsValues.CSR_VIEW_ORDERBOARD
  );

  const latestAck = useSelector(
    (state: RootState) => state.ACKReducer.latestACK
  );

  return (
    <DealerSORActionsContainer
      flex
      middle
      between
      {...testId(ACKTestContainerEnum.DEALER_SOR_ACTIONS)}
    >
      {canSendSpecialOrderApproval && !latestAck && (
        <ModalWrapper
          modal
          lockScroll
          onClose={UtilService.onPopupClose}
          onOpen={UtilService.onPopupOpen}
          trigger={
            <ButtonSecondary
              {...testId(ACKTestButtonEnum.SPECIAL_ORDER_APPROVAL_SEND_BTN)}
              disabled={
                order?.status?.id === OrderStatusEnums.Canceled ||
                order?.status?.id === OrderStatusEnums.Invoiced
              }
            >
              Send Special Order Approval
            </ButtonSecondary>
          }
        >
          {(close: () => void) => (
            <Modal close={close} noHeader>
              <SpecialOrderApprovalModal close={close} />
            </Modal>
          )}
        </ModalWrapper>
      )}
    </DealerSORActionsContainer>
  );
};

export default DealerSORActions;
